(function ($) {
  $(document).ready(function () {
    $(".logo-slider .wrapper .slider-wrap").marquee({
      direction: "left",
      speed: 70,
      gap: 70,
      duplicated: true,
      delayBeforeStart: 0,
      startVisible: true,
    });

    setTimeout(function () {
      $(".logo-slider").css({ opacity: "1" });
    }, 500);
  });
})(jQuery);
